// import { userRegister, login, passwordReset, SendPasswordReset } from './Helpers/ajax/authAjax';
$(document).ready(function() {
    toastr.options = {
        "closeButton": true,
        "progressBar": true,
        "preventDuplicates": true,
    };
    let csrfToken = $('meta[name="csrf-token"]').attr('content');
    // signup form input validation
    $('#signup-form').validate({
        rules : {
            // input fields
            name : {
                required: true,
            },
            email : {
                required: true,
                email: true,
            },
            password : {
                required: true,
                minlength: 4,
            },
            password_confirmation : {
                required: true,
                equalTo: "#password"
            },
            company_name:{
                required: true,
            }
        },
        // input fields error mesaages
        messages : {
            name : {
                required : 'Name is required.',
            },
            email : {
                required : 'Email is required.',
                email : "Email must be a valid email address.",
            },
            password : {
                required : 'Password is required.',
                minlength: "Password must be at least 4 characters."
            },
            password_confirmation : {
                required : 'Confirm password is required.',
                equalTo: "Password and confirm password should same."
            },
            company_name:{
                required: 'Company name or user name is required.',
            }
        },
        // sign up submit button
        submitHandler: function(form) {
            // let formData = new FormData($(form)[0]);

            // userRegister(formData);
            form.submit();
        }
    });

    // login form input validation
    $('#login-form').validate({
        rules : {
            // input fields
            email : {
                required: true,
                email: true,
            },
            password : {
                required: true,
                minlength: 4,
            },
        },
        // input fields error mesaages
        messages : {
            email : {
               required : 'Email is required.',
               email : "Email must be a valid email address.",
            },
            password : {
                required : 'Password is required.',
                minlength: "Password must be at least 4 characters."
            },
        },
        // login submit button
        submitHandler: function(form) {
            form.submit();
        }
    });
    // reset form input validation
    $('#reset-form').validate({
        rules : {
            // input fields
            email : {
                required: true,
                email: true,
            },
            password : {
                required: true,
                minlength: 4,
            },
            password_confirmation : {
                required: true,
                equalTo: "#password"
            }
        },
        // input fields error mesaages
        messages : {
            email : {
                required : 'Email is required.',
                email : "Email must be a valid email address.",
            },
            password : {
                required : 'Password is required.',
                minlength: "Password must be at least 4 characters."
            },
            password_confirmation : {
                required : 'Confirm password is required.',
                equalTo: "Password and confirm password should same."
            }
        },
        //  reset submit button
        submitHandler: function(form) {
            form.submit();}
    });

    //  Function to stop the forget password for the social login user.
    $("#reset-button").click(function(e){
        e.preventDefault();
        var emailValue = $("#email").val();
        if(emailValue === ''){
            $('#error_empty').text('*Email is required.');
            return;
        }else if(!/^([a-zA-Z0-9-_\.])+@([a-zA-Z0-9])+\.([a-zA-Z]{2,10})$/.test(emailValue)){
            $('#error_empty').text('*Email must be a valid email address.');
            return;
        }else{}

        $.ajax({
            url: '/reset/check-email',
            type: 'POST',
            data: {
                'emailValue' : emailValue,
                '_token' : csrfToken,
            },
            dataType: 'JSON',
            async: false

        }).done(function (response) {
            $('#error_empty').text('');
            if(response['is_email_checked'] == true){
               $('#reset-email').submit();
            }else{
                $('#error_empty').text('');
                emailError = '<p class="text-danger fs-5 p-3">You have registered this account using social media login options so there is no password to reset.</p>'
                $('#email-error').html(emailError);
            }

        }).fail(function (error) {
            $('#error_empty').text('');
            emailError = '<p class="text-danger fs-5 p-3">You have registered this account using social media login options so there is no password to reset.</p>'
            $('#email-error').html(emailError);
        })

    });

    if(performance.navigation.type == 1){
        if($(".back-to-login").length == 1){
            $(".back-to-login").trigger('click');
        }
    }

    let timerOn = true;
    function timer(remaining) {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        var resendCodeCheck = `<div class="check_code timer-info p-4">Your code will expires in <i class="fad fa-alarm-exclamation pe-1"></i><span class="fw-bold">` +  m + ':' + s + `</span> seconds.</div>`;
        $('#timer-check-error-msg').html(resendCodeCheck);
        remaining -= 1;
        if(remaining >= 0 && timerOn) {
            setTimeout(function() {
                timer(remaining);
            }, 1000);
            return;
        }
        if(!timerOn) {
            return;
        }
        var resendCodeFail = `<div class="check_code p-4 border-5 border-danger border-start"> Your old verification code is expired. Please click <a type="button" data-id="{{Auth::user()->id}}"
        class="text-danger info-text d-none fw-bold" id="resend-btn">
        Resend code</a> to generate verification code again. </div>`;
        $('#timer-check-error-msg').html(resendCodeFail);
        $('#resend-btn').removeClass('d-none');
        $(".input-disabled").prop('disabled', true);

    }
    if($('.verification-error').length != 1){
        timer(300);
    }

    $('body').on('click', '#resend-btn', function (e) {
        e.preventDefault();
        var user_id = $(this).attr('data-id');
        $.ajax({
            url: '/resend-code',
            type: 'POST',
            data: {
                '_token': csrfToken,
                'user_id': user_id
            },
            async: false
        }).done(function (response) {
            toastr.success('Your verification code resend successfully.');
            $('#resend-btn').addClass('d-none');
            $(".input-disabled").prop('disabled', false);
            timer(300);
        }).fail(function (error) {
            toastr.error('Something went wrong. Please try again after sometimes.');
        })
    });

    $('body').on('click', '#eye-pass', function(e) {
        e.preventDefault();

        var passwordField = $('#password');
        var eyeIcon = $('#eye-pass');

        if (passwordField.attr('type') === 'password') {
          passwordField.attr('type', 'text');
          eyeIcon.removeClass('fa-eye-slash');
          eyeIcon.addClass('fa-eye');
        } else {
          passwordField.attr('type', 'password');
          eyeIcon.removeClass('fa-eye');
          eyeIcon.addClass('fa-eye-slash');
        }
      });

      $('body').on('click', '#eye-confirm-Pass', function(e) {
        e.preventDefault();

        var passwordField = $('#password-confirm');
        var eyeIcon = $('#eye-confirm-Pass');

        if (passwordField.attr('type') === 'password') {
          passwordField.attr('type', 'text');
          eyeIcon.removeClass('fa-eye-slash');
          eyeIcon.addClass('fa-eye');
        } else {
          passwordField.attr('type', 'password');
          eyeIcon.removeClass('fa-eye');
          eyeIcon.addClass('fa-eye-slash');
        }
      });

});
